import React from "react"

const Embed = ({ divId, scriptSrc }) => {

  React.useEffect(() => {
    const script = document.createElement("script")
    script.src = scriptSrc
    script.async = true
    document.body.appendChild(script)
  }, []);

  return (
    <section className={`basic-content`}>
      <div className='basic-content__inner'>
        <div id={divId} data-cid="842" />
      </div>
    </section>
  )
}

export default Embed
